import React from 'react'

// @ts-expect-error: no types in this @gnomad/ui version
import { ExternalLink } from '@gnomad/ui'

import InfoPage from '../base/InfoPage'

const TermsPageContent = () => (
  <InfoPage title="Terms of Use">
    <p>
      This website is intended to provide summary-level results from whole exome sequencing data of
      the Epi25 WES study. The data from this website may not be replicated on any other website
      without written consent. All users of Epi25 browser data agree not to attempt to re-identify
      participants.
    </p>
    <p>
      We encourage you to contact the Epi25 Collaborative before embarking on any analyses using
      these data to check if your proposed analyses overlap with work currently underway by members
      of Epi25.
    </p>
    <p>
      We request that any publications or reports of results obtained from using the information
      available in this browser cite the{' '}
      <ExternalLink href="https://rdcu.be/dVS4z">primary manuscript</ExternalLink> that reports on
      the Epi25 WES analyses. Epi25 does not need to be included as co-authors on your manuscript,
      unless we contributed specific advice or analysis for your work. However, we ask that you
      acknowledge the Epi25 Collaborative as follows:
    </p>
    <blockquote>
      <p>
        The authors would like to thank the Epi25 Collaborative and the individual study teams that
        contributed to this resource. A full list of Epi25 collaborators can be found at{' '}
        <ExternalLink href="https://epi-25.org">epi-25.org</ExternalLink>.
      </p>
    </blockquote>
  </InfoPage>
)

export default TermsPageContent
